var map = {
	"./vip_0.png": 6379,
	"./vip_1.png": 5250,
	"./vip_10.png": 7896,
	"./vip_2.png": 3433,
	"./vip_3.png": 6528,
	"./vip_4.png": 9375,
	"./vip_5.png": 358,
	"./vip_6.png": 1597,
	"./vip_7.png": 468,
	"./vip_8.png": 6387,
	"./vip_9.png": 7530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1704;